// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-4f830fb1] {\n  color: var(--magic-light, #fff);\n}\n\n.title[data-v-4f830fb1] {\n  color: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
